import React, { StrictMode, useEffect} from "react";
import { CookiesProvider } from "react-cookie";
import ApiContextProvider from "./context/ApiContext";
import './i18n'

import { GoogleOAuthProvider } from '@react-oauth/google';
import { Helmet } from 'react-helmet';
import { gaPageView, persistInitialUtm } from "./lib/ga";
import { Switch } from "react-router-dom";


import "./main.scss";

// 基本機能
import Home from "./pages/Home";
import Invite from "./pages/Invite";
import LandingPage from "./pages/LandingPage";
import Userpage from "./pages/Userpage";
import Connections from "./pages/Connections";
import PostPage from "./pages/PostPage";
import PeopleSearch from "./pages/PeopleSearch";
import PostSearch from "./pages/PostSearch";


// 認証
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Register from "./pages/Register";


// 設定
import Settings from "./pages/Settings";
import Account from "./pages/Account";
import AdApplication from "./pages/AdApplication";
import HowTo from "./pages/HowTo";
import LanguageSetting from "./pages/LanguageSetting";
import SensitiveSetting from "./pages/SensitiveSetting";
import Logout from "./pages/Logout";
import NotificationSetting from "./pages/NotificationSetting";
import NotationsSCTA from "./pages/Notations-SCTA";


import { BrowserRouter, Route, Redirect } from "react-router-dom";


import SnackbarProvider from "./context/SnackbarContext";
import Notfound from "./pages/Notfound";
import PostIntent from "./pages/PostIntent";

import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Guidelines from "./pages/Guidelines";
import Contact from "./pages/Contact";


const App = () => {

    // トラッキングIDを環境変数から取得
    const trackingId = process.env.REACT_APP_GA_CODE;

    useEffect(() => {
        persistInitialUtm();                  // 初回UTM保存
        gaPageView(window.location.pathname + window.location.search);
      }, []);
  
    // ルート変更があるたびにページビューをトラッキングするための関数
    const trackPageView = (location) => {
      gaPageView(location.pathname + location.search);
    };

  return (
    <SnackbarProvider>
      <BrowserRouter basename="/" onUpdate={() => trackPageView(window.location)}>
        <ApiContextProvider>
          <StrictMode>
            <CookiesProvider>
              <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENTID}>
              <Helmet>

                </Helmet>
                <Switch>
                {/* 誤ってフロントの /og/* に来た場合でも目的ページへ到達させる */}
                <Route
                  exact
                  path="/og/post/:postId"
                  render={({ match }) => <Redirect to={`/post/${match.params.postId}`} />}
                />
                <Route
                  exact
                  path="/og/post/:postId.html"
                  render={({ match }) => <Redirect to={`/post/${match.params.postId}`} />}
                />
                <Route
                  exact
                  path="/og/user/:userId"
                  render={({ match }) => <Redirect to={`/user/${match.params.userId}`} />}
                />
                <Route
                  exact
                  path="/og/user/:userId.html"
                  render={({ match }) => <Redirect to={`/user/${match.params.userId}`} />}
                />
                <Route exact path="/login" component={Login} />
                <Route exact path="/home" component={Home} />
                <Route exact path="/" component={Home} />
                <Route exact path="/invite" component={Invite} />
                <Route exact path="/landingpage" component={LandingPage} />
                <Route exact path="/userpage" component={Userpage} />
                <Route exact path="/logout" component={Logout} />
                <Route exact path="/settings" component={Settings} />
                <Route exact path="/account" component={Account} />
                <Route exact path="/user/:userId" component={Userpage} />
                <Route exact path="/adapplication" component={AdApplication} />
                <Route exact path="/howto" component={HowTo} />
                <Route exact path="/Notations-SCTA" component={NotationsSCTA} />
                <Route exact path="/notificationsetting" component={NotificationSetting} />
                <Route exact path="/auth/callback" component={AuthCallback} />
                <Route exact path="/register" component={Register} />
                <Route exact path="/usersearch" component={PeopleSearch} />
                <Route path="/post/:postId" component={PostPage} exact />
                <Route exact path="/postsearch" component={PostSearch} />
                <Route path="/languagesetting" exact component={LanguageSetting} />
                <Route path="/sensitivesetting" exact component={SensitiveSetting} />
                <Route path="/connections" component={Connections} />
                <Route exact path="/post-intent" component={PostIntent} />
                {/* Legal */}
                <Route exact path="/terms" component={Terms} />
                <Route exact path="/privacy" component={Privacy} />
                <Route exact path="/guidelines" component={Guidelines} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/eula" render={() => <Redirect to="/terms" />} />
                <Route component={Notfound} />
                </Switch>
              </GoogleOAuthProvider>
            </CookiesProvider>
          </StrictMode>
        </ApiContextProvider>
      </BrowserRouter>
    </SnackbarProvider>
  );
};

export default App;
